module.exports = __webpack_public_path__ + "media/flat/amex-0f65cbe1.svg";